import React from "react";
import AdminBroadcastModal from "./AdminBroadcastModal";
import AdminMessageBanner from "./AdminMessageBanner";

/**
 * Admin broadcast chrome (banner + popup) for the agent dashboard.
 * Personal notes / reminders drawer removed.
 */
export default function RemindersChrome() {
  return (
    <>
      <AdminMessageBanner />
      <AdminBroadcastModal />
    </>
  );
}
